import * as React from 'react';
import { useState, useRef } from 'react';
import Button from 'antd/lib/button';
import { LeafletMap } from './leafletmap';
import { Props } from 'one-ui';
import { CalledDest } from 'one-state-calldest/src/CalledDest';
import { PharmacyData } from 'one-state-patient-pharmacy/src/PharmacyData';
import { Box, BoxBody, BoxHeader } from 'one-ui-box';
import SendSMSModal from './send-sms-modal';
import MapModal from './map-modal';
import { useCtx } from 'one-ui-provider';

/**
 * Represents Map Props Attributes
 */
export interface CardProps extends Props {
  title?: string;
  address?: string;
  calldest?: CalledDest;
  pharmacies?: PharmacyData[];
  callerNumber?: string;
}


/**
 * This function returns the Map
 * @param props has all input parameters to load the Card
 * @returns JSX code for Map UI
 */
export const MapCard = ({ title, address, calldest, pharmacies, callerNumber }: CardProps): JSX.Element => {
  const [expanded, setExpanded] = useState(false);
  const [showSMSModal, setShowSMSModal] = useState(false);
  const mainRef = useRef<HTMLDivElement>(null);
  const { settings: { map_config } } = useCtx();
  const { send_sms } = map_config;
  const [mapSettings, setMapSettings] = useState({
    pharmCheck: false,
    prefPharCheck: false,
    hospCheck: false,
    callDestCheck: false,
  })

  const mapNode = useRef(null)

  /**
   * Expand map on/off
   */
  const handleExpandMap = () => {
    if (expanded) mapNode.current.showMarkers();
    setExpanded(!expanded);
  };

  const handleOpenSMSModal = () => {
    setShowSMSModal(true);
  };

  const handleCloseSMSModal = () => {
    setShowSMSModal(false);
  };


  return (
    <Box ref={mainRef}>
      <BoxHeader title={title} titleWidth={7} titleColor="#e84a13">
        <Button size="small" className="ant-btn--spacer" onClick={handleExpandMap}>
          {`${expanded ? 'Exit' : 'Show'} Full Map`}
        </Button>
        {(send_sms) && (<Button size="small" type="primary" className="ant-btn--spacer" onClick={handleOpenSMSModal}>
          Send SMS
        </Button>)}
      </BoxHeader>
      <BoxBody>
        <LeafletMap
          ref={mapNode}
          setMapSettings={setMapSettings}
          address={address}
          calldest={calldest}
          pharmacies={pharmacies}
          expanded={false}
          settings={mapSettings} />
      </BoxBody>
      {
        expanded &&
        <MapModal
          open={expanded}
          title={title}
          content={
            <LeafletMap
              setMapSettings={setMapSettings}
              address={address}
              calldest={calldest}
              pharmacies={pharmacies}
              expanded={true}
              settings={mapSettings} />
          }
          onOpenSMSModal={handleOpenSMSModal}
          onClose={handleExpandMap}
        />
      }
      <SendSMSModal
        open={showSMSModal}
        proceeding={false}
        callerNumber={callerNumber}
        onClose={handleCloseSMSModal}
        onSend={handleCloseSMSModal}
      />
    </Box>
  );
};
